import { StorageKeywordKey } from '../../types/storage'
import { fetchSuggestions } from '../../services/autoComplete'

export interface AutoCompleteState {
  isOpen: boolean
  isActive: boolean
  keyword: string
  keywordQuery: string[]
  selected: number
  totalCount: number
  data: object
}

const initialState: AutoCompleteState = {
  isOpen: false,
  isActive: true,
  keyword: '',
  keywordQuery: [],
  selected: -1,
  totalCount: 0,
  data: {},
}

// actions
const OPEN = 'gnb/autoComplete/OPEN'
const CLOSE = 'gnb/autoComplete/CLOSE'
const TOGGLE = 'gnb/autoComplete/TOGGLE'
const ACTIVATE = 'gnb/autoComplete/ACTIVATE'
const DEACTIVATE = 'gnb/autoComplete/DEACTIVATE'
const FETCH = 'gnb/autoComplete/FETCH'
const SET_SELECTED = 'gnb/autoComplete/SET_SELECTED'

// action creators
export const toggleAutoComplete = () => {
  return {
    type: TOGGLE,
  }
}

export const openAutoComplete = () => {
  return {
    type: OPEN,
  }
}

export const closeAutoComplete = () => {
  return {
    type: CLOSE,
  }
}

export const activateAutoComplete = () => {
  return {
    type: ACTIVATE,
  }
}

export const deactivateAutoComplete = () => {
  return {
    type: DEACTIVATE,
  }
}

export const fetchAutoComplete = (keyword: string, recentKeywords?: StorageKeywordKey[]) => async dispatch => {
  const result = await fetchSuggestions(keyword, recentKeywords)

  dispatch({
    type: FETCH,
    payload: result,
  })
}

export const setSelected = (index: number) => {
  return {
    type: SET_SELECTED,
    selected: index,
  }
}

// reducers
const reducers = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE:
      return {
        ...state,
        isOpen: !state.isOpen,
        selected: -1,
      }
    case OPEN:
      return {
        ...state,
        isOpen: true,
        selected: -1,
      }
    case CLOSE:
      return {
        ...state,
        isOpen: false,
        selected: -1,
      }
    case ACTIVATE:
      return {
        ...state,
        isActive: true,
      }
    case DEACTIVATE:
      return {
        ...state,
        isActive: false,
      }
    case FETCH:
      return {
        ...state,
        ...action.payload,
        selected: -1,
      }
    case SET_SELECTED:
      return {
        ...state,
        selected: action.selected,
      }
    default:
      return state
  }
}

export default reducers
